module.exports = __webpack_public_path__ + "img/astral-txt_12.7ef2eaa2.svg";